import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../axios";
import UpdateQuestions from "../../../Components/QuestionEditCreate/UpdateQustion";
import OperationType from "../../../Enum/OperationTypeEnum";
import ComponentType from "../../../Enum/ComponentTypeEnum";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const EditQBank = ({ componentType }) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [editData, setEditData] = useState([]);
  const [click, setClick] = useState();
  const [questions, setQuestions] = useState([]);
  const [openPopupDupli, setOpenPopupDupli] = useState(false);
  const [hidePopupCheck, setHidePopupCheck] = useState(false);
  const [viewErrorMsg, setViewErrorMsg] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [isopenPopupDupli, isSetOpenPopupDupli] = useState(false);
  const [showErrorInputField, setShowErrorInputField] = useState(false);
  const [getErrorMsg, setGetErrorMsg] = useState("");
  const [copyPrevSettings, setCopyPrevSettings] = useState(true);

  // 🔥 AI UI enable karne ke liye selectedBox
  const [selectedBox, setSelectedBox] = useState("auto-evaluate");

  const skillsData = useSelector((state) => state.initialData.skills);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const [questionBankDetails, setQuestionBankDetails] = useState({
    name: null,
    description: null,
    type_idL: null,
    standard_id: null,
    section_id: null,
    subject_id: null,
    total_duration: null,
    deadline: null,
    schedule_date: null,
    tags: null,
    schedule_time: null,
  });
  const { standard_id, subject_id, section_id } = questionBankDetails;

  useEffect(() => {
    if (!questions || questions.length === 0) return;

    const hasEdited = questions.some((q) => q.is_question_edited);
    if (!hasEdited) return;

    setTimeout(() => {
      localStorage.setItem(
        `DraftQBLocal-${state.qsbid}`,
        JSON.stringify(questions),
      );
    }, 500);
  }, [questions]);

  const getQB = async () => {
    let res;
    if (state?.b4sid) {
      res = await axios.get(`/api/v1/b4sQuestion/get/${state?.b4sid}`);
      setEditData(() => [res.data.data]);
    } else if (state?.qsbid) {
      res = await axios.get(`/api/v1/questionbank/getById/${state?.qsbid}`);
    }

    if (res) {
      const {
        id,
        name,
        description,
        type_id,
        teacher_id,
        subject_id,
        section_id,
        standard_id,
        deadline,
        tags,
        total_duration,
      } = res?.data?.data;

      setQuestionBankDetails((prev) => ({
        ...prev,
        id,
        name,
        description,
        teacher_id: teacher_id,
        type_id: type_id?.id,
        subject_id,
        section_id,
        standard_id,
        tags,
        total_duration,
        deadline,
      }));

      if (state?.localData) {
        const localSaved = JSON.parse(
          localStorage.getItem(`DraftQBLocal-${state.qsbid}`) || "{}",
        );
        if (localSaved) {
          setQuestions(localSaved);
          return;
        }
      }

      if (res?.data?.data?.questions?.length > 0) {
        const fetchedQuestions = res.data.data.questions.map((question) => ({
          id: question?.id, // Keep ID for duplicate check
          standard_id: question?.standard_id?.id,
          section_id: question?.section_id?.id,
          subject_id: question?.subject_id?.id,
          book_id: question?.book_id?.id,
          chapter_id: question?.chapter_id?.id,
          type_id: question?.type_id?.id,
          question_type: String(question?.type_id?.isManuallyGraded),
          domain_id: question?.domain_id?.id,
          skill_id: question?.skill_id?.id,
          difficulty_level: question?.difficulty_level?.id,
          title: question?.title,
          correct_score: question?.correct_score,
          is_mandatory: question?.is_mandatory,
          add_to: question?.add_to || "all",
          add_to_mock: question?.add_to_mock || false,
          attachments: question?.attachments,
          options: question?.options,
          correct_answers: question?.correct_answers,
          // 🔥 FIX: AI Data include karo
          ...(question?.subjective_evaluation && {
            subjective_evaluation: {
              enabled: question.subjective_evaluation.enabled || false,
              expectedAnswer:
                question.subjective_evaluation.expectedAnswer || "",
              rubric: question.subjective_evaluation.rubric || [],
            },
          }),
        }));

        setQuestions(fetchedQuestions);
      }
    }
  };

  useEffect(() => {
    getQB();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBaseQuestionTemplate = () => {
    return {
      standard_id: standard_id ? standard_id?.id : null,
      subject_id: subject_id ? subject_id?.id : null,
      section_id: section_id ? section_id?.id : null,
      book_id: "",
      chapter_id: null,
      question_type: "null",
      type_id: "",
      domain_id: null,
      skill_id: null,
      difficulty_level: null,
      title: null,
      correct_score: null,
      is_mandatory: false,
      add_to: "all",
      add_to_mock: false,
      attachments: [],
      options: [
        { key: "A", value: null },
        { key: "B", value: null },
        { key: "C", value: null },
        { key: "D", value: null },
      ],
      correct_answers: [
        {
          option_key: null,
          value: null,
          reason_for_answer: { explanation: null },
        },
      ],
    };
  };

  const addMoreQuestion = () => {
    setQuestions((prev) => {
      const baseQuestion = getBaseQuestionTemplate();

      if (copyPrevSettings && prev.length > 0) {
        const previous = prev[prev.length - 1];
        const isMCQ = previous.question_type === "false";

        return [
          ...prev,
          {
            ...baseQuestion,
            book_id: previous.book_id,
            chapter_id: previous.chapter_id,
            skill_id: previous.skill_id,
            domain_id: previous.domain_id,
            difficulty_level: previous.difficulty_level,
            correct_score: previous.correct_score,
            add_to: "all",
            add_to_mock: false,
            type_id: previous.type_id,
            question_type: previous.question_type,
            options: isMCQ
              ? [
                  { key: "A", value: null },
                  { key: "B", value: null },
                ]
              : [],
            correct_answers: isMCQ
              ? [
                  {
                    option_key: null,
                    value: null,
                    reason_for_answer: { attachment: null, explanation: null },
                  },
                ]
              : [
                  {
                    reason_for_answer: { explanation: null, attachments: null },
                  },
                ],
            // 🔥 Copy AI settings if Descriptive
            ...(!isMCQ && {
              subjective_evaluation: {
                enabled: false,
                expectedAnswer: "",
                rubric: [],
              },
            }),
          },
        ];
      }

      return [...prev, baseQuestion];
    });
  };

  const handleUpdateQsBank = async () => {
    // 🔥 Payload Clean
    const cleanedQuestions = questions.map((q) => {
      const question = { ...q };
      if (question.is_question_edited || question.id === undefined) {
        delete question.id;
      }

      if (question.question_type === "false") {
        delete question.subjective_evaluation;
      } else if (question.subjective_evaluation) {
        const finalRubric = question.subjective_evaluation.enabled
          ? question.subjective_evaluation.rubric.filter(
              (r) =>
                (r.criterion && r.criterion.trim()) || Number(r.maxMarks) > 0,
            )
          : [];
        question.subjective_evaluation = {
          enabled: question.subjective_evaluation.enabled || false,
          expectedAnswer: question.subjective_evaluation.expectedAnswer || "",
          rubric: finalRubric,
        };
      }
      return question;
    });

    let newAssessment = {
      name: questionBankDetails?.name,
      description: questionBankDetails?.description,
      type_id: questionBankDetails?.type_id,
      standard_id: questionBankDetails?.standard_id?.id,
      subject_id: questionBankDetails?.subject_id?.id,
      teacher_id: questionBankDetails?.teacher_id,
      section_id: questionBankDetails?.section_id?.id,
      status: "draft",
      total_duration: questionBankDetails?.total_duration,
      questions: cleanedQuestions,
    };

    try {
      let res = await axios.put(
        `/api/v1/questionBank/update/${questionBankDetails?.id}`,
        newAssessment,
      );
      res && navigate("/questionLibrary");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      localStorage.removeItem(`DraftQBLocal-${state.qsbid}`);
    }
  };

  const findDuplicateQuestions = () => {
    // ... (Same as before)
    const seen = new Set();
    const duplicates = [];
    let hasNoDuplicate = false;
    questions.forEach((question, index) => {
      const id = question.id || question.b4sQuestion;
      if (question.is_question_edited || !id) return;
      if (seen.has(id)) {
        duplicates.push(index + 1);
        hasNoDuplicate = true;
      } else {
        seen.add(id);
      }
    });
    if (duplicates.length > 0) {
      setViewErrorMsg(`Duplicate question found at Q${duplicates.join(", Q")}`);
      isSetOpenPopupDupli(true);
      hasNoDuplicate = true;
    } else {
      isSetOpenPopupDupli(false);
    }
    setHidePopupCheck(hasNoDuplicate);
    return !hasNoDuplicate;
  };

  const checkAllDataField = () => {
    let hasError = false;
    questions.forEach((question, index) => {
      if (!question.title) {
        setGetErrorMsg(`Title missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.skill_id) {
        setGetErrorMsg(`Skill missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.type_id) {
        setGetErrorMsg(`Question Type missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.chapter_id) {
        setGetErrorMsg(`Book & Chapter missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.correct_score) {
        setGetErrorMsg(`Correct Score missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.difficulty_level) {
        setGetErrorMsg(`Difficulty Level missing in question ${index + 1}`);
        hasError = true;
      }

      if (componentType === ComponentType.QUESTION_BANK) {
        if (!question?.add_to || question.add_to.trim() === "") {
          setGetErrorMsg(`Add to missing in question ${index + 1}`);
          hasError = true;
        }
      }

      // 🔥 Descriptive validation skip
      const isDescriptive = question.question_type === "true";
      if (
        !isDescriptive &&
        Array.isArray(question.options) &&
        question.options.length > 0
      ) {
        question.options.forEach((opt) => {
          if (!opt?.key || opt.key.trim() === "") {
            setGetErrorMsg(`Option key missing in question ${index + 1}`);
            hasError = true;
          }
          if (!opt?.value || opt.value.trim() === "") {
            setGetErrorMsg(`Option value missing in question ${index + 1}`);
            hasError = true;
          }
        });
      }
      if (!isDescriptive && Array.isArray(question.correct_answers)) {
        question?.correct_answers?.forEach((ans) => {
          if (question?.options?.length > 0) {
            if (!ans?.option_key || ans.option_key.trim() === "") {
              setGetErrorMsg(`Option key missing in question ${index + 1}`);
              hasError = true;
            }
          }
        });
      }
    });
    if (hasError) {
      setShowErrorInputField(true);
      return true;
    }
    return false;
  };

  const findTotalMarks = () => {
    return questions.reduce(
      (acc, curr) => acc + Number(curr?.correct_score),
      0,
    );
  };

  return (
    <UpdateQuestions
      operationType={OperationType.UPDATE}
      setClickFromCreate={setClick}
      assessmentDetails={questionBankDetails}
      setAssessmentDetails={setQuestionBankDetails}
      componentType={ComponentType.QUESTION_BANK}
      questions={questions}
      showErrorInputField={showErrorInputField}
      setShowErrorInputField={setShowErrorInputField}
      getErrorMsg={getErrorMsg}
      setQuestions={setQuestions}
      addMoreQuestion={addMoreQuestion}
      checkAllDataField={checkAllDataField}
      findTotalMarks={findTotalMarks}
      openPopupDupli={openPopupDupli}
      hidePopupCheck={hidePopupCheck}
      viewErrorMsg={viewErrorMsg}
      findDuplicateQuestions={findDuplicateQuestions}
      handleCreateAssessment={handleUpdateQsBank}
      setOpenPopup={setOpenPopup}
      openPopup={openPopup}
      setOpenPopupDupli={setOpenPopupDupli}
      isSetOpenPopupDupli={isSetOpenPopupDupli}
      isopenPopupDupli={isopenPopupDupli}
      copyPrevSettings={copyPrevSettings}
      setCopyPrevSettings={setCopyPrevSettings}
      // 🔥 YEH 2 PROPS ADD KARO
      selectedBox={selectedBox}
      hasDescriptiveAutoAssessment={true}
    />
  );
};

export default EditQBank;
